import { createSlice } from "@reduxjs/toolkit";

const initialState = {
  "data": [
    {
      "id": "proxy_ssh_auth_failed_test",
      "severity": 2,
      "createdAt": 1779370780520,
      "siteId": "site_1",
      "siteName": "Taipei Site",
      "accountId": "user_1",
      "accountName": "Ivan",
      "orgId": "org_1",
      "orgName": "D-Link",
      "eventType": "PROXY_SSH_AUTH_FAILED",
      "deviceName": "Unity Proxy 01",
      "deviceMacAddress": "00:11:22:33:44:55",
      "deviceType": "proxy",
      "payload": {
        "translationKey": "proxy_ssh_auth_failed",
        "targetDeviceName": "AP 03",
        "targetDeviceIp": "192.168.1.15"
      },
      "acknowledge": false
    },
    {
      "id": "proxy_ssh_timeout_test",
      "severity": 2,
      "createdAt": 1779370780521,
      "siteId": "site_1",
      "siteName": "Taipei Site",
      "accountId": "user_1",
      "accountName": "Ivan",
      "orgId": "org_1",
      "orgName": "D-Link",
      "eventType": "PROXY_SSH_TIMEOUT",
      "deviceName": "Unity Proxy 01",
      "deviceMacAddress": "00:11:22:33:44:55",
      "deviceType": "proxy",
      "payload": {
        "translationKey": "proxy_ssh_timeout",
        "targetDeviceName": "Switch 02",
        "targetDeviceIp": "192.168.1.30"
      },
      "acknowledge": false
    },
    {
      "id": "proxy_ssh_reject_test",
      "severity": 2,
      "createdAt": 1779370780522,
      "siteId": "site_1",
      "siteName": "Taipei Site",
      "accountId": "user_1",
      "accountName": "Ivan",
      "orgId": "org_1",
      "orgName": "D-Link",
      "eventType": "PROXY_SSH_REJECT",
      "deviceName": "Unity Proxy 02",
      "deviceMacAddress": "00:11:22:33:44:66",
      "deviceType": "proxy",
      "payload": {
        "translationKey": "proxy_ssh_reject",
        "targetDeviceName": "Router 01",
        "targetDeviceIp": "192.168.1.1"
      },
      "acknowledge": false
    },
    {
      "id": "proxy_ssh_failed_test",
      "severity": 2,
      "createdAt": 1779370780523,
      "siteId": "site_1",
      "siteName": "Taipei Site",
      "accountId": "user_1",
      "accountName": "Ivan",
      "orgId": "org_1",
      "orgName": "D-Link",
      "eventType": "PROXY_SSH_FAILED",
      "deviceName": "Unity Proxy 02",
      "deviceMacAddress": "00:11:22:33:44:66",
      "deviceType": "proxy",
      "payload": {
        "translationKey": "proxy_ssh_failed",
        "targetDeviceName": "Switch 05",
        "targetDeviceIp": "192.168.1.55",
        "sslErrno": "Connection refused"
      },
      "acknowledge": false
    },
    {
      "id": "null",
      "severity": 6,
      "createdAt": 1765354545324,
      "siteId": null,
      "siteName": null,
      "accountId": null,
      "accountName": null,
      "orgId": null,
      "orgName": null,
      "eventType": "SYSTEM_AUDIT",
      "deviceName": null,
      "deviceMacAddress": null,
      "deviceType": null,
      "payload": {
        "translationKey": "null",
      },
      "acknowledge": true
    },
    {
      "id": "ap_online",
      "severity": 6,
      "createdAt": 1763710780520,
      "siteId": "ap_online",
      "siteName": null,
      "accountId": null,
      "accountName": null,
      "orgId": "ap_online",
      "orgName": null,
      "eventType": "Device",
      "deviceName": "ap_online",
      "deviceMacAddress": null,
      "deviceType": "ap",
      "payload": {
        "translationKey": "ap_online",
      },
      "acknowledge": true
    },
    {
      "id": "ap_offline",
      "severity": 2,
      "createdAt": 1763710780520,
      "siteId": "ap_offline",
      "siteName": "20250930_site_123",
      "accountId": "2",
      "accountName": "2",
      "orgId": "2",
      "orgName": "2",
      "eventType": "Device",
      "deviceName": "ap_offline",
      "deviceMacAddress": "2",
      "deviceType": "ap",
      "payload": {
        "translationKey": "ap_offline",
      },
      "acknowledge": true
    },
    {
      "id": "ap_adopt",
      "severity": 6,
      "createdAt": 1763710780520,
      "siteId": "ap_adopt",
      "siteName": "20250930_site_123",
      "accountId": "3",
      "accountName": "3",
      "orgId": "3",
      "orgName": "3",
      "eventType": "Device",
      "deviceName": "ap_adopt",
      "deviceMacAddress": "3",
      "deviceType": "ap",
      "payload": {
        "translationKey": "ap_adopt",
      },
      "acknowledge": false
    },
    {
      "id": "ap_client_joined",
      "severity": 6,
      "createdAt": 1763710780520,
      "siteId": "ap_client_joined",
      "siteName": "20250930_site_123",
      "accountId": "3",
      "accountName": "3",
      "orgId": "3",
      "orgName": "3",
      "eventType": "Device",
      "deviceName": "ap_client_joined",
      "deviceMacAddress": "3",
      "deviceType": "ap",
      "payload": {
        "translationKey": "ap_client_joined",
        "macAddress": "9E:1F:79:7C:C9:5D",
        "reasonCode": "OK_PSK",
        "manufacturer": "Apple",
        "ipAddress": "10.33.18.183"
      },
      "acknowledge": false
    },
    {
      "id": "ap_client_left",
      "severity": 6,
      "createdAt": 1763710780520,
      "siteId": "ap_client_left",
      "siteName": "20250930_site_123",
      "accountId": "3",
      "accountName": "3",
      "orgId": "3",
      "orgName": "3",
      "eventType": "Device",
      "deviceName": "ap_client_left",
      "deviceMacAddress": "3",
      "deviceType": "ap",
      "payload": {
        "translationKey": "ap_client_left",
        "clientName": "test",
        "macAddress": "9E:1F:79:7C:C9:5D",
        "manufacturer": "Apple",
      },
      "acknowledge": false
    },
    {
      "id": "ap_ip_changed",
      "severity": 2,
      "createdAt": 1763710780520,
      "siteId": "ap_ip_changed",
      "siteName": "20250930_site_123",
      "accountId": "3",
      "accountName": "3",
      "orgId": "3",
      "orgName": "3",
      "eventType": "Device",
      "deviceName": "ap_ip_changed",
      "deviceMacAddress": "3",
      "deviceType": "ap",
      "payload": {
        "translationKey": "ap_ip_changed",
        "ipAddress": "10.32.33.11",
      },
      "acknowledge": false
    },
    {
      "id": "ap_radio_changed",
      "severity": 4,
      "createdAt": 1763710780520,
      "siteId": "ap_radio_changed",
      "siteName": "20250930_site_123",
      "accountId": "3",
      "accountName": "3",
      "orgId": "3",
      "orgName": "3",
      "eventType": "Device",
      "deviceName": "ap_radio_changed",
      "deviceMacAddress": "3",
      "deviceType": "ap",
      "payload": {
        "translationKey": "ap_radio_changed",
        "oldChannel": "1",
        "newChannel": "11",
        "band": "5G"
      },
      "acknowledge": false
    },
    {
      "id": "sw_online",
      "severity": 6,
      "createdAt": 1763710780520,
      "siteId": "sw_online",
      "siteName": "20250930_site_123",
      "accountId": "3",
      "accountName": "3",
      "orgId": "3",
      "orgName": "3",
      "eventType": "Device",
      "deviceName": "sw_online",
      "deviceMacAddress": "3",
      "deviceType": "switch",
      "payload": {
        "translationKey": "sw_online",
      },
      "acknowledge": false
    },
    {
      "id": "sw_offline",
      "severity": 2,
      "createdAt": 1763710780520,
      "siteId": "sw_offline",
      "siteName": "20250930_site_123",
      "accountId": "3",
      "accountName": "3",
      "orgId": "3",
      "orgName": "3",
      "eventType": "Device",
      "deviceName": "sw_offline",
      "deviceMacAddress": "3",
      "deviceType": "switch",
      "payload": {
        "translationKey": "sw_offline",
      },
      "acknowledge": false
    },
    {
      "id": "sw_adopt",
      "severity": 6,
      "createdAt": 1763710780520,
      "siteId": "sw_adopt",
      "siteName": "20250930_site_123",
      "accountId": "3",
      "accountName": "3",
      "orgId": "3",
      "orgName": "3",
      "eventType": "Device",
      "deviceName": "sw_adopt",
      "deviceMacAddress": "3",
      "deviceType": "switch",
      "payload": {
        "translationKey": "sw_adopt",
      },
      "acknowledge": false
    },
    {
      "id": "sw_ip_changed",
      "severity": 2,
      "createdAt": 1763710780520,
      "siteId": "sw_ip_changed",
      "siteName": "20250930_site_123",
      "accountId": "3",
      "accountName": "3",
      "orgId": "3",
      "orgName": "3",
      "eventType": "Device",
      "deviceName": "sw_ip_changed",
      "deviceMacAddress": "3",
      "deviceType": "switch",
      "payload": {
        "translationKey": "sw_ip_changed",
        "ipAddress": "10.32.33.11"
      },
      "acknowledge": false
    },
    {
      "id": "sw_port_linkup",
      "severity": 6,
      "createdAt": 1763710780520,
      "siteId": "sw_port_linkup",
      "siteName": "20250930_site_123",
      "accountId": "3",
      "accountName": "3",
      "orgId": "3",
      "orgName": "3",
      "eventType": "Device",
      "deviceName": "sw_port_linkup",
      "deviceMacAddress": "3",
      "deviceType": "switch",
      "payload": {
        "translationKey": "sw_port_linkup",
        "portNum": 5
      },
      "acknowledge": false
    },
    {
      "id": "sw_port_linkdown",
      "severity": 6,
      "createdAt": 1763710780520,
      "siteId": "sw_port_linkdown",
      "siteName": "20250930_site_123",
      "accountId": "3",
      "accountName": "3",
      "orgId": "3",
      "orgName": "3",
      "eventType": "Device",
      "deviceName": "sw_port_linkdown",
      "deviceMacAddress": "3",
      "deviceType": "switch",
      "payload": {
        "translationKey": "sw_port_linkdown",
        "portNum": 5
      },
      "acknowledge": false
    },
    {
      "id": "sw_port_error",
      "severity": 2,
      "createdAt": 1763710780520,
      "siteId": "sw_port_error",
      "siteName": "20250930_site_123",
      "accountId": "3",
      "accountName": "3",
      "orgId": "3",
      "orgName": "3",
      "eventType": "Device",
      "deviceName": "sw_port_error",
      "deviceMacAddress": "3",
      "deviceType": "switch",
      "payload": {
        "translationKey": "sw_port_error",
        "portNum": 5,
        "errorType": 1
      },
      "acknowledge": false
    },
    {
      "id": "sw_port_error_recover",
      "severity": 6,
      "createdAt": 1763710780520,
      "siteId": "sw_port_error_recover",
      "siteName": "20250930_site_123",
      "accountId": "3",
      "accountName": "3",
      "orgId": "3",
      "orgName": "3",
      "eventType": "Device",
      "deviceName": "sw_port_error_recover",
      "deviceMacAddress": "3",
      "deviceType": "switch",
      "payload": {
        "translationKey": "sw_port_error_recover",
        "portNum": 5,
        "errorType": 1
      },
      "acknowledge": false
    },
    {
      "id": "router_online",
      "severity": 6,
      "createdAt": 1763710780520,
      "siteId": "router_online",
      "siteName": "20250930_site_123",
      "accountId": "3",
      "accountName": "3",
      "orgId": "3",
      "orgName": "3",
      "eventType": "Device",
      "deviceName": "router_online",
      "deviceMacAddress": "3",
      "deviceType": "router",
      "payload": {
        "translationKey": "router_online",
      },
      "acknowledge": false
    },
    {
      "id": "router_offline",
      "severity": 2,
      "createdAt": 1763710780520,
      "siteId": "router_offline",
      "siteName": "20250930_site_123",
      "accountId": "3",
      "accountName": "3",
      "orgId": "3",
      "orgName": "3",
      "eventType": "Device",
      "deviceName": "router_offline",
      "deviceMacAddress": "3",
      "deviceType": "router",
      "payload": {
        "translationKey": "router_offline",
      },
      "acknowledge": false
    },
    // SYSTEM_AUDIT
    {
      "id": "device_fw_upgrade_schedule_create",
      "severity": 6,
      "createdAt": 1763710780520,
      "siteId": "device_fw_upgrade_schedule_create",
      "siteName": "20250930_site_123",
      "accountId": "3",
      "accountName": "3",
      "orgId": "3",
      "orgName": "3",
      "eventType": "SYSTEM_AUDIT",
      "deviceName": "device_fw_upgrade_schedule_create",
      "deviceMacAddress": "3",
      "deviceType": "switch",
      "payload": {
        "translationKey": "device_fw_upgrade_schedule_create",
        "upgradeWindow": "xxxx",
        "modelName": "xxx"
      },
      "acknowledge": false
    },
    {
      "id": "device_fw_upgrade_schedule_cancel",
      "severity": 6,
      "createdAt": 1763710780520,
      "siteId": "device_fw_upgrade_schedule_cancel",
      "siteName": "20250930_site_123",
      "accountId": "3",
      "accountName": "3",
      "orgId": "3",
      "orgName": "3",
      "eventType": "SYSTEM_AUDIT",
      "deviceName": "device_fw_upgrade_schedule_cancel",
      "deviceMacAddress": "3",
      "deviceType": "switch",
      "payload": {
        "translationKey": "device_fw_upgrade_schedule_cancel",
        "modelName": "xxx"
      },
      "acknowledge": false
    },
    {
      "id": "device_fw_upgrade_schedule_change",
      "severity": 6,
      "createdAt": 1763710780520,
      "siteId": "device_fw_upgrade_schedule_change",
      "siteName": "20250930_site_123",
      "accountId": "3",
      "accountName": "3",
      "orgId": "3",
      "orgName": "3",
      "eventType": "SYSTEM_AUDIT",
      "deviceName": "device_fw_upgrade_schedule_change",
      "deviceMacAddress": "3",
      "deviceType": "switch",
      "payload": {
        "translationKey": "device_fw_upgrade_schedule_change",
        "upgradeWindow": "xxxx",
        "modelName": "xxx",
        "oldVersion": "1.1.1",
        "newVersion": "1.1.1"
      },
      "acknowledge": false
    },
    {
      "id": "invite_user_org",
      "severity": 6,
      "createdAt": 1763710780520,
      "siteId": "invite_user_org",
      "siteName": "20250930_site_123",
      "accountId": "3",
      "accountName": "3",
      "orgId": "3",
      "orgName": "3",
      "eventType": "SYSTEM_AUDIT",
      "deviceName": "invite_user_org",
      "deviceMacAddress": "3",
      "deviceType": "switch",
      "payload": {
        "translationKey": "invite_user_org",
        "changedAccountName": "xxx",
        "changedAccountId": "xxx"
      },
      "acknowledge": false
    },
    {
      "id": "invite_user_site",
      "severity": 6,
      "createdAt": 1763710780520,
      "siteId": "invite_user_site",
      "siteName": "20250930_site_123",
      "accountId": "3",
      "accountName": "3",
      "orgId": "3",
      "orgName": "3",
      "eventType": "SYSTEM_AUDIT",
      "deviceName": "invite_user_site",
      "deviceMacAddress": "3",
      "deviceType": "switch",
      "payload": {
        "translationKey": "invite_user_site",
        "changedAccountName": "xxx",
        "changedAccountId": "xxx"
      },
      "acknowledge": false
    },
    {
      "id": "remove_user_org",
      "severity": 6,
      "createdAt": 1763710780520,
      "siteId": "remove_user_org",
      "siteName": "20250930_site_123",
      "accountId": "3",
      "accountName": "3",
      "orgId": "3",
      "orgName": "3",
      "eventType": "SYSTEM_AUDIT",
      "deviceName": "remove_user_org",
      "deviceMacAddress": "3",
      "deviceType": "switch",
      "payload": {
        "translationKey": "remove_user_org",
        "changedAccountName": "xxx",
        "changedAccountId": "xxx"
      },
      "acknowledge": false
    },
    {
      "id": "remove_user_site",
      "severity": 6,
      "createdAt": 1763710780520,
      "siteId": "remove_user_site",
      "siteName": "20250930_site_123",
      "accountId": "3",
      "accountName": "3",
      "orgId": "3",
      "orgName": "3",
      "eventType": "SYSTEM_AUDIT",
      "deviceName": "remove_user_site",
      "deviceMacAddress": "3",
      "deviceType": "switch",
      "payload": {
        "translationKey": "remove_user_site",
        "changedAccountName": "xxx",
        "changedAccountId": "xxx"
      },
      "acknowledge": false
    },
    {
      "id": "user_leave_org",
      "severity": 6,
      "createdAt": 1763710780520,
      "siteId": "user_leave_org",
      "siteName": "20250930_site_123",
      "accountId": "3",
      "accountName": "3",
      "orgId": "3",
      "orgName": "3",
      "eventType": "SYSTEM_AUDIT",
      "deviceName": "user_leave_org",
      "deviceMacAddress": "3",
      "deviceType": "switch",
      "payload": {
        "translationKey": "user_leave_org",
        "changedAccountName": "xxx",
        "changedAccountId": "xxx"
      },
      "acknowledge": false
    },
    {
      "id": "user_leave_site",
      "severity": 6,
      "createdAt": 1763710780520,
      "siteId": "user_leave_site",
      "siteName": "20250930_site_123",
      "accountId": "3",
      "accountName": "3",
      "orgId": "3",
      "orgName": "3",
      "eventType": "SYSTEM_AUDIT",
      "deviceName": "user_leave_site",
      "deviceMacAddress": "3",
      "deviceType": "switch",
      "payload": {
        "translationKey": "user_leave_site",
        "changedAccountName": "xxx",
        "changedAccountId": "xxx"
      },
      "acknowledge": false
    },
    {
      "id": "change_user_privilege",
      "severity": 6,
      "createdAt": 1763710780520,
      "siteId": "change_user_privilege",
      "siteName": "20250930_site_123",
      "accountId": "3",
      "accountName": "3",
      "orgId": "3",
      "orgName": "3",
      "eventType": "SYSTEM_AUDIT",
      "deviceName": "change_user_privilege",
      "deviceMacAddress": "3",
      "deviceType": "switch",
      "payload": {
        "translationKey": "change_user_privilege",
        "changedAccountName": "xxx",
        "changedAccountId": "xxx"
      },
      "acknowledge": false
    },
    {
      "id": "captive_portal_created",
      "severity": 6,
      "createdAt": 1763710780520,
      "siteId": "captive_portal_created",
      "siteName": "20250930_site_123",
      "accountId": "3",
      "accountName": "3",
      "orgId": "3",
      "orgName": "3",
      "eventType": "SYSTEM_AUDIT",
      "deviceName": "captive_portal_created",
      "deviceMacAddress": "3",
      "deviceType": "switch",
      "payload": {
        "translationKey": "captive_portal_created",
        "name": "xxx",
      },
      "acknowledge": false
    },
    {
      "id": "captive_portal_changed",
      "severity": 6,
      "createdAt": 1763710780520,
      "siteId": "captive_portal_changed",
      "siteName": "20250930_site_123",
      "accountId": "3",
      "accountName": "3",
      "orgId": "3",
      "orgName": "3",
      "eventType": "SYSTEM_AUDIT",
      "deviceName": "captive_portal_changed",
      "deviceMacAddress": "3",
      "deviceType": "switch",
      "payload": {
        "translationKey": "captive_portal_changed",
        "name": "xxx",
      },
      "acknowledge": false
    },
    {
      "id": "captive_portal_delete",
      "severity": 6,
      "createdAt": 1763710780520,
      "siteId": "captive_portal_delete",
      "siteName": "20250930_site_123",
      "accountId": "3",
      "accountName": "3",
      "orgId": "3",
      "orgName": "3",
      "eventType": "SYSTEM_AUDIT",
      "deviceName": "captive_portal_delete",
      "deviceMacAddress": "3",
      "deviceType": "switch",
      "payload": {
        "translationKey": "captive_portal_delete",
        "name": "xxx",
      },
      "acknowledge": false
    },
    {
      "id": "device_removed",
      "severity": 6,
      "createdAt": 1763710780520,
      "siteId": "device_removed",
      "siteName": "20250930_site_123",
      "accountId": "3",
      "accountName": "3",
      "orgId": "3",
      "orgName": "3",
      "eventType": "SYSTEM_AUDIT",
      "deviceName": "device_removed",
      "deviceMacAddress": "3",
      "deviceType": "switch",
      "payload": {
        "translationKey": "device_removed",
      },
      "acknowledge": false
    },
    {
      "id": "device_moved",
      "severity": 6,
      "createdAt": 1763710780520,
      "siteId": "device_moved",
      "siteName": "20250930_site_123",
      "accountId": "3",
      "accountName": "3",
      "orgId": "3",
      "orgName": "3",
      "eventType": "SYSTEM_AUDIT",
      "deviceName": "device_moved",
      "deviceMacAddress": "3",
      "deviceType": "switch",
      "payload": {
        "translationKey": "device_moved",
        "newSiteName": "xxxx",
        "newSiteId": "xxxx"
      },
      "acknowledge": false
    },
    {
      "id": "wireless_created",
      "severity": 6,
      "createdAt": 1763710780520,
      "siteId": "wireless_created",
      "siteName": "20250930_site_123",
      "accountId": "3",
      "accountName": "3",
      "orgId": "3",
      "orgName": "3",
      "eventType": "SYSTEM_AUDIT",
      "deviceName": "wireless_created",
      "deviceMacAddress": "3",
      "deviceType": "switch",
      "payload": {
        "translationKey": "wireless_created",
        "networkName": "xxx"
      },
      "acknowledge": false
    },
    {
      "id": "wireless_changed",
      "severity": 6,
      "createdAt": 1763710780520,
      "siteId": "wireless_changed",
      "siteName": "20250930_site_123",
      "accountId": "3",
      "accountName": "3",
      "orgId": "3",
      "orgName": "3",
      "eventType": "SYSTEM_AUDIT",
      "deviceName": "wireless_changed",
      "deviceMacAddress": "3",
      "deviceType": "switch",
      "payload": {
        "translationKey": "wireless_changed",
        "networkName": "xxx"
      },
      "acknowledge": false
    },
    {
      "id": "device_radio_changed",
      "severity": 6,
      "createdAt": 1763710780520,
      "siteId": "device_radio_changed",
      "siteName": "20250930_site_123",
      "accountId": "3",
      "accountName": "3",
      "orgId": "3",
      "orgName": "3",
      "eventType": "SYSTEM_AUDIT",
      "deviceName": "device_radio_changed",
      "deviceMacAddress": "3",
      "deviceType": "switch",
      "payload": {
        "translationKey": "device_radio_changed",
      },
      "acknowledge": false
    },
    {
      "id": "device_network_changed",
      "severity": 6,
      "createdAt": 1763710780520,
      "siteId": "device_network_changed",
      "siteName": "20250930_site_123",
      "accountId": "3",
      "accountName": "3",
      "orgId": "3",
      "orgName": "3",
      "eventType": "SYSTEM_AUDIT",
      "deviceName": "device_network_changed",
      "deviceMacAddress": "3",
      "deviceType": "switch",
      "payload": {
        "translationKey": "device_network_changed",
      },
      "acknowledge": false
    },
    {
      "id": "org_time_zone_changed",
      "severity": 6,
      "createdAt": 1763710780520,
      "siteId": "org_time_zone_changed",
      "siteName": "20250930_site_123",
      "accountId": "3",
      "accountName": "3",
      "orgId": "3",
      "orgName": "3",
      "eventType": "SYSTEM_AUDIT",
      "deviceName": "org_time_zone_changed",
      "deviceMacAddress": "3",
      "deviceType": "switch",
      "payload": {
        "translationKey": "org_time_zone_changed",
      },
      "acknowledge": false
    },
    {
      "id": "site_time_zone_changed",
      "severity": 6,
      "createdAt": 1763710780520,
      "siteId": "site_time_zone_changed",
      "siteName": "20250930_site_123",
      "accountId": "3",
      "accountName": "3",
      "orgId": "3",
      "orgName": "3",
      "eventType": "SYSTEM_AUDIT",
      "deviceName": "site_time_zone_changed",
      "deviceMacAddress": "3",
      "deviceType": "switch",
      "payload": {
        "translationKey": "site_time_zone_changed",
      },
      "acknowledge": false
    },
    {
      "id": "device_info_changed",
      "severity": 6,
      "createdAt": 1763710780520,
      "siteId": "device_info_changed",
      "siteName": "20250930_site_123",
      "accountId": "3",
      "accountName": "3",
      "orgId": "3",
      "orgName": "3",
      "eventType": "SYSTEM_AUDIT",
      "deviceName": "device_info_changed",
      "deviceMacAddress": "3",
      "deviceType": "switch",
      "payload": {
        "translationKey": "device_info_changed",
        "oldData": "xxx", // json object...
        "newData": "xxx"
      },
      "acknowledge": false
    },
    {
      "id": "wired_port_changed",
      "severity": 6,
      "createdAt": 1763710780520,
      "siteId": "wired_port_changed",
      "siteName": "20250930_site_123",
      "accountId": "3",
      "accountName": "3",
      "orgId": "3",
      "orgName": "3",
      "eventType": "SYSTEM_AUDIT",
      "deviceName": "wired_port_changed",
      "deviceMacAddress": "3",
      "deviceType": "switch",
      "payload": {
        "translationKey": "wired_port_changed",
        "oldData": "xxx", // json object...
        "newData": "xxx"
      },
      "acknowledge": false
    },
    {
      "id": "port_profile_changed",
      "severity": 6,
      "createdAt": 1763710780520,
      "siteId": "port_profile_changed",
      "siteName": "20250930_site_123",
      "accountId": "3",
      "accountName": "3",
      "orgId": "3",
      "orgName": "3",
      "eventType": "SYSTEM_AUDIT",
      "deviceName": "port_profile_changed",
      "deviceMacAddress": "3",
      "deviceType": "switch",
      "payload": {
        "translationKey": "device_info_changed",
        "oldData": "xxx", // json object...
        "newData": "xxx"
      },
      "acknowledge": false
    },
    {
      id: "device_sync_failed_test",
      severity: 2,
      createdAt: 1779370780520,
      siteId: "site_1",
      siteName: "Taipei Site",
      accountId: "user_1",
      accountName: "Ivan",
      orgId: "org_1",
      orgName: "D-Link",
      eventType: "SYSTEM_AUDIT",
      deviceName: "Unity AP 01",
      deviceMacAddress: "00:11:22:33:44:55",
      deviceType: "ap",
      payload: {
        translationKey: "device_sync_failed",
      },
      acknowledge: false,
    }
  ],
  "updateData": []
}

export const eventsSlice = createSlice({
  name: "events",
  initialState,
  reducers: {
    updateEventsSite: (state, action) => {
      const { eventIds } = action.payload.data;

      state.updateData = {
        data: eventIds.map((eventId) => ({
          eventId,
          status: "success",
        })),
      };
    },
  },
});

export const { updateEventsSite } = eventsSlice.actions;
export default eventsSlice.reducer;
